import Block from "domain/Block";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import useScheduleBlock from "hooks/apollo/blocks/useScheduleBlock";
import useGetAllLines from "hooks/apollo/line/useGetLines";
import useGetWorkOrders from "hooks/apollo/workOrder/useGetWorkOrders";
import useUpdateWorkOrder from "hooks/apollo/workOrder/useUpdateWorkOrder";
import useBlockCreateModal from "hooks/state/useBlockCreateModal";
import useWorkBlockModal from "hooks/state/useWorkBlockModal";
import React, { useState } from "react";
import CreateBlockModalView from "./CreateBlockModalView";

export default function CreateBlockModalContainer() {
  const applicationContext = useApplicationContext();
  const { block: blockData, isOpen, close } = useBlockCreateModal();
  const { lines } = useGetAllLines({ activeOnly: true });
  const { workOrders } = useGetWorkOrders();
  const scheduleBlock = useScheduleBlock();
  const updateWorkOrder = useUpdateWorkOrder();
  const workBlockModalUIState = useWorkBlockModal();
  const handleSave = (block) => {
    const newBlock = Block.buildWithBlockTime(block);
    scheduleBlock(newBlock);
    if (block.__typename === "WorkBlock") {
      updateWorkOrder({ id: block.workOrder.id, notes: block.workOrder.notes });
    }
  };
  const [tab, setTab] = useState(0);
  const handleTabClick = (_event, index) => {
    setTab(index);
  };
  const [workBlockErrors, setWorkBlockErrors] = useState({});
  const [downtimeErrors, setDowntimeErrors] = useState({});

  if (!blockData) return null;

  const handleClose = () => {
    setWorkBlockErrors({});
    setDowntimeErrors({});
    close();
  };

  return (
    <CreateBlockModalView
      applicationContext={applicationContext}
      blockData={blockData}
      downtimeErrors={downtimeErrors}
      isOpen={isOpen}
      lines={lines}
      onClose={handleClose}
      onSave={handleSave}
      onTabClick={handleTabClick}
      setDowntimeErrors={setDowntimeErrors}
      setWorkBlockErrors={setWorkBlockErrors}
      tab={tab}
      workBlockErrors={workBlockErrors}
      workBlockModalUIState={workBlockModalUIState}
      workOrders={workOrders}
    />
  );
}
